import React from "react";

const NoRecords = () => {
  return (
    <div
      style={{
        textAlign: "center",
        padding: "1.5rem 0rem",
        backgroundColor: "#fff",
      }}
    >
      There are no records to display
    </div>
  );
};

export default NoRecords;
